// import React, { useState, useEffect, useRef } from "react";
// import "react-toastify/dist/ReactToastify.css";
// import Main from "./Main";
// import Breadcrumbs from "@mui/material/Breadcrumbs";
// import MUILink from "@mui/material/Link";
// import Typography from "@mui/material/Typography";
// import ServicesForm from "../BBPSBillPayment/ServicesForm";
// import { Autocomplete, TextField } from "@mui/material";

// import { fetch_bill_operators, fetch_billPay_info, submit_billPay_amount } from "../api/billPayApi";
// import { getLocation } from "../components/Navigator/Navigator";
// import { useParams, useSearchParams } from "react-router-dom";
// import { useInactivityTimeout } from "../hooks/useInactivityTimeout";
// import { useNotify } from "../context/NotifyContext";
// const Electricity = () => {
//   const [electricityProvider, setElectricityProvider] = useState("");
//   const [showDetails, setShowDetails] = useState(false);
//   const [details, setDetails] = useState(null);
//   const [operator,setOperator] = useState(null)

// const [fetchLoading, setFetchLoading] = useState(false);
// const [payLoading, setPayLoading] = useState(false);
//   const [operators, setOperators] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedOperatorId, setSelectedOperatorId] = useState("");
//   const [selectedOperator, setSelectedOperator] = useState(null);
//   const [searchParams, setSearchParams] = useSearchParams();
//   const {slug} = useParams()
//   const {notify} = useNotify()
  
//   const fetchedRef = useRef(null);
//   const toastShownRef = useRef(false);
//   const clearSession = () => {
//     fetchedRef.current = null;
//     toastShownRef.current = false;
//     setSearchParams({}, { replace: true });
//     setElectricityProvider("");
//     setDetails(null);
//     setShowDetails(false);
//   };
// useInactivityTimeout(() => {
//   if (showDetails) {
//     clearSession();
//     notify("Session expired due to inactivity", "info");
//   }
// }, 10 * 60 * 1000);

// const electricityOperators = operators.filter(
//   (op) => op.category?.toLowerCase() === "electricity"
// );


// useEffect(() => {
//   if (selectedOperatorId && operators.length) {
//     const op = operators.find(o => o.operatorId === selectedOperatorId);
//     setSelectedOperator(op);
//     console.log("get selected op",op)
//   }
// }, [selectedOperatorId, operators]);


//   useEffect(() => {
//     const load = async () => {
//       const res = await fetch_bill_operators();
//       if (res?.success) {
//         setOperators(res.data?.operators || []);
//         setCategories(res.data?.categories || []);
//       }
//     };
//     load();
//   }, []);

  
// const handleSubmit = (e) => {
//   e.preventDefault();

//   if (!selectedOperatorId) {
//     notify("Please select electricity operator", "error");
//     return;
//   }

//   if (!electricityProvider) {
//     notify("Consumer number required", "error");
//     return;
//   }

//   if (electricityProvider.length < 5) {
//     notify("Invalid consumer number", "error");
//     return;
//   }

//   setSearchParams({ 
//     canumber: electricityProvider,
//     operator: selectedOperatorId
//   });
// };



// const fetchBillByCanumber = async (canumber) => {
 
//   if (fetchLoading) return;
//   setFetchLoading(true);

//   try {
//     const payload = {
//       mode: "online",
//       canumber,
//       operatorId: selectedOperatorId
//     };

//     const result = await fetch_billPay_info(payload);


//   if (result?.success && result?.data?.bill) {
//   notify(result.message || "Bill details fetched successfully", "success");
//   setDetails(result.data.bill);
//   setOperator(result.data.operator);
//   setShowDetails(true);
// } else {
//   notify(result?.message || "Bill not found", "error");
//   clearSession();
// }

//   } catch {
//     notify("Server error", "error");
//     clearSession();
//   } finally {
//     setFetchLoading(false);
//   }
// };

// useEffect(() => {
//   const canumber = searchParams.get("canumber");
//   const opId = searchParams.get("operator");

//   if (!canumber || !opId) return;

//   setSelectedOperatorId(opId);
//   setElectricityProvider(canumber);

//   setTimeout(() => {
//     fetchBillByCanumber(canumber);
//   }, 200);
// }, [searchParams]);





// const handleSubmitFromChild = async (data) => {
//   if (!electricityProvider || !data?.amount) {
//     notify("All fields are required", "error");
//     return;
//   }
// if ( !details && !selectedOperatorId) {
//   notify("Operator required", "error");
//   return;
// }




//   setPayLoading(true);
//   try {
//     const location = await getLocation();
//     const payload = {
//       amount: data.amount,
//       bill_fetch: details?.bill_fetch,
//       canumber: electricityProvider,
//       latitude: location.latitude,
//       longitude: location.longitude,
//       operator:selectedOperatorId,
//       category: slug
//     };

//     const result = await submit_billPay_amount(payload);

//     if (result?.success) {
//       notify(result?.message || "Payment Successful", "success");
//       clearSession();
//     } else {
//       notify(result?.message || "Payment failed", "error");
//     }
//   } catch {
//     notify("Server error", "error");
//   } finally {
//     setPayLoading(false);
//   }
// };

//   const handleClose = () =>{
// setSearchParams()
// setDetails(null)
// setElectricityProvider('')
//   }




//   return (
//     <Main showRightPanel={false}>
//       <Breadcrumbs className="mb-4">
//         <Typography>Dashboard</Typography>
//         <MUILink  underline="hover" color="inherit">Recharge & Bills</MUILink>
//         <MUILink underline="hover" color="inherit">Electricity Bill</MUILink>
//       </Breadcrumbs>
//       <div className="flex flex-col lg:flex-row gap-6 mt-4">
//         <div className="bg-white ds-card p-4 w-full max-w-[260px] h-fit">
//           <h2  className="font-semibold mb-4">Electricity Bill</h2>
//        <form onSubmit={handleSubmit} className="space-y-4">

//   {/* Operator Label */}
//   <label className="text-sm font-medium text-gray-700">
//     Select Electricity Operator
//   </label>

//   <Autocomplete
//     options={electricityOperators}
//     getOptionLabel={(op) => op.name || ""}
//     value={selectedOperator}
//     onChange={(e, newValue) => {
//       setSelectedOperator(newValue);
//       setSelectedOperatorId(newValue?.operatorId || "");
//     }}
//     renderInput={(params) => (
//       <TextField {...params} placeholder="Search Operator" size="small" />
//     )}
//   />

//  <div className="mt-3">
//    {/* Consumer Number */}
//   <label className="text-sm font-medium text-gray-700">
//    {selectedOperator?.displayname ?? "Consumer Number"} 
//   </label>

//   <input
//     type="text"
//     placeholder="Enter Consumer Number"
//     value={electricityProvider}
//     onChange={(e) => setElectricityProvider(e.target.value)}
//     className="w-full border rounded p-2"
//   />
//  </div>

//   <button
//     type="submit"
//     disabled={fetchLoading}
//     className="w-full bg-blue-100 text-blue-700 py-2 rounded"
//   >
//     {fetchLoading ? "Fetching..." : "Check Bill"}
//   </button>

// </form>

//         </div>
//         {showDetails && details && (
//           <div className="w-full max-w-sm">
//         <ServicesForm
//   bill={details}
//   close={handleClose}
//   onSubmit={handleSubmitFromChild}
//   loading={payLoading}
// />

//           </div>
//         )}
//       </div>
//     </Main>
//   );
// };
// export default Electricity;



import React, { useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import Main from "./Main";
import AppBreadcrumbs from "../components/ui/AppBreadcrumbs";
import ServicesForm from "../BBPSBillPayment/ServicesForm";
import { Autocomplete, TextField } from "@mui/material";

import { fetch_bill_operators, fetch_billPay_info, submit_billPay_amount } from "../api/billPayApi";
import { getLocation } from "../components/Navigator/Navigator";
import { useParams, useSearchParams } from "react-router-dom";
import { useInactivityTimeout } from "../hooks/useInactivityTimeout";
import { useNotify } from "../context/NotifyContext";
import { useWallet } from "../context/walletContext";

const Electricity = () => {
  const { slug } = useParams();
  const { notify } = useNotify();
const {refreshWalletCart} = useWallet()
  const [operators, setOperators] = useState([]);
  const [selectedOperatorId, setSelectedOperatorId] = useState("");
  const [selectedOperator, setSelectedOperator] = useState(null);

  const [canumber, setCanumber] = useState("");
  const [adFields, setAdFields] = useState({ ad1: "", ad2: "", ad3: "", ad4: "" });
  const [paymentType, setPaymentType] = useState("");

  const [details, setDetails] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const [fetchLoading, setFetchLoading] = useState(false);
  const [payLoading, setPayLoading] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const fetchedRef = useRef(null);
  const toastShownRef = useRef(false);

  // ================= LOAD OPERATORS =================
  useEffect(() => {
    const load = async () => {
      const res = await fetch_bill_operators();
      if (res?.success) setOperators(res.data?.operators || []);
    };
    load();
  }, []);

  // ================= FILTER ELECTRICITY OPS =================
  const electricityOperators = operators.filter(
    (op) => op.category?.toLowerCase() === "electricity"
  );

  // ================= SELECT OPERATOR =================
  useEffect(() => {
    const op = operators.find(o => String(o.operatorId) === String(selectedOperatorId));
    setSelectedOperator(op || null);

    // Reset fields
    setCanumber("");
    setAdFields({ ad1: "", ad2: "", ad3: "", ad4: "" });
    setPaymentType("");
    setDetails(null);
    setShowDetails(false);
  }, [selectedOperatorId]);

  // ================= SESSION CLEAR =================
  const clearSession = () => {
    fetchedRef.current = null;
    toastShownRef.current = false;
    setSearchParams({}, { replace: true });
    setCanumber("");
    setDetails(null);
    setShowDetails(false);
  };

  useInactivityTimeout(() => {
    if (showDetails) {
      clearSession();
      notify("Session expired due to inactivity", "info");
    }
  }, 10 * 60 * 1000);

  // ================= CANUMBER CHANGE (LPG LOGIC) =================
  const handleCanumberChange = (e) => {
    const value = e.target.value;
    setCanumber(value);

    if (selectedOperator?.category === "LPG") {
      if (value.length > 10) {
        setAdFields((p) => ({ ...p, ad1: "1" }));
      } else {
        setAdFields((p) => ({ ...p, ad1: "2" }));
      }
    }
  };

  // ================= VALIDATION =================
  const validateInput = () => {
    if (!selectedOperator) return notify("Select operator", "error");

    if (!canumber.trim()) {
      notify(`Enter ${selectedOperator.displayname || "Consumer Number"}`, "error");
      return false;
    }

    // Regex validation
    if (selectedOperator.regex) {
      try {
        const reg = new RegExp(selectedOperator.regex);
        if (!reg.test(canumber)) {
          notify("Invalid Consumer Number Format", "error");
          return false;
        }
      } catch {}
    }

    // Dynamic ad fields
    ["ad1", "ad2", "ad3", "ad4"].forEach((k) => {
      if (selectedOperator?.[`${k}_name`] && !adFields[k]) {
        notify(`Enter ${selectedOperator[`${k}_d_name`]}`, "error");
        throw new Error("Stop Validation");
      }
    });

    // Hero FinCorp special
    if (String(selectedOperatorId) === "157" && !paymentType) {
      notify("Select Payment Type", "error");
      return false;
    }

    return true;
  };

  // ================= FETCH BILL =================
  const fetchBill = async () => {
    try {
      if (!validateInput()) return;
    } catch {
      return;
    }

    setFetchLoading(true);
    try {
      const adPayload = {};
      ["ad1", "ad2", "ad3", "ad4"].forEach((k) => {
        if (selectedOperator?.[`${k}_name`] && adFields[k]) {
          adPayload[k] = String(adFields[k]).trim();
        }
      });

      const payload = {
        mode: "online",
        operatorId: selectedOperatorId,
        canumber: String(canumber).trim(),
        ...adPayload,
        paymentType: String(selectedOperatorId) === "157" ? paymentType : undefined,
      };

      console.log("🔥 ELECTRICITY BILL FETCH PAYLOAD:", payload);

      const res = await fetch_billPay_info(payload);

      if (res?.success && res?.data?.bill) {
        notify("Bill fetched successfully", "success");
        setDetails(res.data.bill);
        setShowDetails(true);
      } else {
        notify(res?.message || "Bill not found", "error");
        clearSession();
      }
    } catch (err) {
      console.error("Fetch Error:", err);
      notify("Server error", "error");
    } finally {
      setFetchLoading(false);
    }
  };

  // ================= PAY BILL =================
  const handleSubmitFromChild = async (data) => {
    if (!data?.amount) return notify("Enter amount", "error");

    setPayLoading(true);
    try {
      const location = await getLocation();

      const adPayload = {};
      ["ad1", "ad2", "ad3", "ad4"].forEach((k) => {
        if (selectedOperator?.[`${k}_name`] && adFields[k]) {
          adPayload[k] = String(adFields[k]).trim();
        }
      });

      const payload = {
        amount: data.amount,
        bill_fetch: details?.bill_fetch,
        canumber,
        operator: selectedOperatorId,
        category: slug,
        latitude: location.latitude,
        longitude: location.longitude,
        paymentType: String(selectedOperatorId) === "157" ? paymentType : undefined,
        ...adPayload,
      };

      console.log("🔥 ELECTRICITY PAYMENT PAYLOAD:", payload);

      const res = await submit_billPay_amount(payload);

      if (res?.success) {
        refreshWalletCart()
        notify("Payment Successful", "success");
        clearSession();
      } else {
        notify(res?.message || "Payment Failed", "error");
      }
    } catch (err) {
      console.error("Payment Error:", err);
      notify("Server error", "error");
    } finally {
      setPayLoading(false);
    }
  };

  // ================= UI =================
  return (
    <Main showRightPanel={false}>
      <AppBreadcrumbs
        items={[
          { label: "Dashboard", to: "/" },
          { label: "Recharge & Bills" },
          { label: "Electricity Bill" },
        ]}
      />

      <div className="flex flex-col lg:flex-row gap-6 mt-4">

        {/* LEFT FORM */}
        <div className="ds-card p-4 w-full max-w-[280px]">

          <h2 className="font-semibold mb-3">Electricity Bill</h2>

          {/* OPERATOR */}
          <label className="text-sm font-medium">Select Operator</label>
          <Autocomplete
            options={electricityOperators}
            getOptionLabel={(op) => op.name || ""}
            value={selectedOperator}
            onChange={(e, v) => {
              setSelectedOperator(v);
              setSelectedOperatorId(v?.operatorId || "");
            }}
            renderInput={(params) => <TextField {...params} size="small" />}
          />

          {/* CONSUMER NUMBER */}
       <div className="mt-2" >
           <label className="text-sm font-medium mt-4 ">
            {selectedOperator?.displayname || "Consumer Number"} <span className="text-red-400 pr-1">*</span>
          </label>
          <input
            value={canumber}
            onChange={handleCanumberChange}
            className="w-full border rounded p-2 mt-1"
          />
       </div>

          {/* HERO FINCORP PAYMENT TYPE */}
          {String(selectedOperatorId) === "157" && (
            <div className="mt-2">
              <label className="text-sm font-medium">Payment Type</label>
              <Autocomplete
                options={["Installment Amount Due", "Full Overdue", "Advance EMI", "Foreclosure"]}
                value={paymentType}
                onChange={(e, v) => setPaymentType(v)}
                renderInput={(p) => <TextField {...p} size="small" />}
              />
            </div>
          )}

          {/* DYNAMIC AD FIELDS */}
          {["ad1", "ad2", "ad3", "ad4"].map((k) =>
            selectedOperator?.[`${k}_name`] ? (
              <div key={k} className="mt-2">
                <label className="text-sm font-medium">
                  {selectedOperator[`${k}_d_name`]}
                </label>
                <TextField
                  fullWidth
                  size="small"
                  value={adFields[k]}
                  onChange={(e) => setAdFields({ ...adFields, [k]: e.target.value })}
                />
              </div>
            ) : null
          )}

          <button
            onClick={fetchBill}
            disabled={fetchLoading}
            className="ds-btn ds-btn-primary ds-btn-block mt-3"
          >
            {fetchLoading ? "Fetching..." : "Check Bill"}
          </button>
        </div>

        {/* BILL DETAILS FORM */}
        {showDetails && details && (
          <div className="w-full max-w-sm">
            <ServicesForm
              bill={details}
              onSubmit={handleSubmitFromChild}
              loading={payLoading}
              close={clearSession}
            />
          </div>
        )}
      </div>
    </Main>
  );
};

export default Electricity;
